import * as React from 'react';
import NotificationActions from '../../actions/NotificationActions';
import AjaxPromises from '../../utils/AjaxPromises.js';
import PasswordCheck from '../../utils/PasswordCheck';
import * as _ from 'lodash';
import { endPoints as EndPoints } from '../../constants/AuthConstants';
import HttpClient from '../../utils/HttpClient';

class Reset extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loading     : false,
            password1   : '',
            password2   : '',
            strength    : 0,
            token       : this.props.token,
            complexityError      : false,
            matchingError      : false,
            complexityStatus   : '',
            matchingStatus   : '',
            passwordSettings: {
                PasswordLengthEnabled: false
            },           
            passwordStrength    : '',
            passwordStrengthValue: 0
        };

        this.onFirstPasswordChange  = this.onFirstPasswordChange.bind(this);
        this.onSecondPasswordChange = this.onSecondPasswordChange.bind(this);
        this.slowCheck = _.debounce(this.checkPassword, 1000, {leading: false, trailing: true});
        this.fastCheck = this.checkPassword.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.getPasswordSettings = this.getPasswordSettings.bind(this);
        this.createPasswordStrengthLabel = this.createPasswordStrengthLabel.bind(this);
    }

    componentDidMount() {
        this.getPasswordSettings();
    }

    conponentWillUnmount() {
        this.setState({
            loading             : false,
            password1           : '',
            password2           : '',
            strength            : 0,
            token               : this.props.token,
            complexityError     : false,
            matchingError       : false,
            complexityStatus    : '',
            matchingStatus      : '',           
            passwordStrength    : '',
            passwordStrengthValue: 0
        });
        
    }

    onFirstPasswordChange(e) {
        this.setState({ password1 : e.target.value })
        this.slowCheck(1);
        this.createPasswordStrengthLabel();
    }

    onSecondPasswordChange(e) {
        this.setState({ password2 : e.target.value }),
        this.slowCheck(2);
    }

    checkPassword(check) {
        var password = this.state.password1,
            confirmPassword = this.state.password2;

        if (check == 1) {
            var complexityError = PasswordCheck.checkComplexity(password, this.state.passwordSettings);

            if (complexityError) {
                this.setState({ complexityError: true, complexityStatus: complexityError.idStatus });
                NotificationActions.addNotification({ type: 'error', sticky: false, body: complexityError.notification, timer: 5500 });
                return true;
            }
            if (!complexityError) {
                this.setState({ complexityError: '', complexityStatus: '' })
                return false;
            }

        } else {
            if (this.state.complexityError) {
                return;
            } else {
                
                var matchingError = PasswordCheck.checkMatching(password, confirmPassword);

                if (matchingError) {
                    this.setState({ matchingError: true, matchingStatus: matchingError.idStatus });
                    NotificationActions.addNotification({ type: 'error', sticky: false, body: matchingError.notification, timer: 5000 });
                    return true;
                }
                if (!matchingError) {
                    this.setState({ matchingError: '', matchingStatus: '' });
                    return false;
                }
            }
        }
    }

    resetPassword(e) {
        e.preventDefault();

        var password = this.state.password1,
        confirmPassword = this.state.password2;

        var complexityFailed = this.fastCheck(1);
        var matchingFailed = this.fastCheck(2);

        if (this.state.loading) {
            return;
        }
        
        if (complexityFailed || matchingFailed) {
            return;
        }
        
        if (!complexityFailed && !matchingFailed) {
            this.setState({ loading : true }, async () => {
                const resp = await HttpClient.post(EndPoints.RESET, {
                    'password'          : this.state.password2,
                    'passwordToken'     : this.state.token,
                });
                
                if (!!resp) {
                    window.location.href = '../';
                }

                this.setState({ loading: false });
            });
        }
    }

    getPasswordSettings(){
        AjaxPromises.GET(EndPoints.PASSWORD_SETTINGS+ '?resetToken=' +  this.state.token
        ).then(res => {
                if(res.Result){
                    this.setState({passwordSettings:res.Data});
                }
            }
        );
    }

    createPasswordStrengthLabel(){
        const passwordStrengthValue = PasswordCheck.getPasswordStrength(this.state.password1);
        this.setState({passwordStrengthValue});
        switch (passwordStrengthValue) {
            case 0:
                this.setState({passwordStrength: 'Weak'});
                return;
            case 1:
                this.setState({passwordStrength: 'Weak'});
                return;
            case 2:
                this.setState({passwordStrength: 'Fair'});
                return;
            case 3:
                this.setState({passwordStrength: 'Good'});
                return;
            case 4:
                this.setState({passwordStrength: 'Strong'});
                return;
            default:
                this.setState({passwordStrength: 'Weak'});
                return;
        }
    }

    render() {
        return (
            <form
                id='reset'
                className='auth'>

                <div className='auth__background' />

                <div className='auth__content' style={{height:'490px'}}>

                    <div className='auth__content--logo'>
                        <img src='/assets/logo.png' />
                    </div>

                    <p>Please enter a long, uncommon password.</p>

                    <input
                        type='password'
                        id='auth-password1'
                        value={this.state.password1}
                        className={this.state.complexityStatus}
                        onChange={this.onFirstPasswordChange} 
                        onBlur={this.onFirstPasswordChange} 
                        onFocus={() => this.setState({ complexityError : '', complexityStatus : '' })}
                    />
                    <progress
                        style={{width:'80%'}}
                        value={this.state.passwordStrengthValue}
                        max='4'>
                    </progress>
                    <small>
                        <label style={{width:'20%'}}>
                            { true && (
                                    <p style={{paddingLeft:'5px', paddingTop: '0px'}}> {this.state.passwordStrength}</p>
                            )}
                        </label>
                    </small>

                    <p>Please re-enter your password</p>

                    <input
                        type='password'
                        id='auth-password2'
                        disabled={this.state.complexityError}
                        value={this.state.password2}
                        className={this.state.matchingStatus}
                        onChange={this.onSecondPasswordChange}
                        onFocus={() => this.setState({ matchingError : '', matchingStatus : '' })}
                    />


                    <button
                        className='auth__reset btn-primary btn-green'
                        onClick={this.resetPassword}>

                        { !this.state.loading ? 'Reset' : <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> }
                    </button>
                </div>


            </form>
        );
    }
}

export default Reset;



// WEBPACK FOOTER //
// ./ui_src/app/components/reset/Reset.react.jsx